import { render } from "./RlDetail.vue?vue&type=template&id=4524e416&scoped=true"
import script from "./RlDetail.vue?vue&type=script&lang=js"
export * from "./RlDetail.vue?vue&type=script&lang=js"

import "./RlDetail.vue?vue&type=style&index=0&id=4524e416&lang=less&scoped=true"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4524e416"]])

export default __exports__